import styles from '@components/components/AddressPicker/AddressPicker.module.scss';
import Suggestions from '@components/components/AddressPicker/components/Suggestions/Suggestions';
import React from 'react';
import { InputField, Pill } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const getValue = (label, value) => {
  if (label === 'PLZ:' && value?.split(' ').length > 0) {
    return value?.split(' ')[0];
  }
  if (label === 'Hausnummer:' && value?.split('/').length > 0) {
    return value?.split('/')[0];
  }
  return value;
};

const AutocompleteInputField = ({
  store,
  name,
  label,
  disabled,
  value,
  suggestions,
  menu,
  handleSuggestionClick,
  handleResetValue,
  inputRef,
  noBorder,
  isSkipped,
}) => {
  const pillValue = getValue(label, value);

  return (
    <div className={styles.inputGroup}>
      {value ? (
        <div className={styles.tagContainer}>
          <label className={styles.label}>{label}</label>
          <Pill
            className={styles.tag}
            glyph="times"
            onClick={handleResetValue}
            variant="tag"
          >
            {pillValue}
          </Pill>
        </div>
      ) : (
        <>
          <InputField
            autoComplete="off"
            className={classNames(styles.inputContainer, {
              [styles.skipped]: isSkipped,
            })}
            disabled={disabled}
            label={label}
            name={name}
            noMessage
            ref={inputRef}
            store={store}
            variant={noBorder ? ' ' : 'closed'}
          />
          <Suggestions
            onClick={v => handleSuggestionClick(name, v)}
            store={menu}
            suggestions={suggestions}
          />
        </>
      )}
    </div>
  );
};

export default AutocompleteInputField;
